import useApiHelpers from "./helpers";

const { getRequest } = useApiHelpers();

export default function useCountryEndpoints() {
  const getCountries = async () => {
    const response = await getRequest("/countries");
    return response;
  };

  return {
    getCountries,
  };
}
